export default __webpack_public_path__ + "static/media/s4_male.7ab8740f.wav";